export const ERROR_CODES = {
	// 1
	PROJECT: {
		// 1
		MIP: {
			// 01
			CREATE: {
				// 01
				GENERAL_DEAL_INPUTS: {
					// Security is already used, can't delete
					11010101: 11010101,
					// Security name and type pair already exist
					11010102: 11010102,
					// Loan definition is already used, can't delete
					11010103: 11010103,
					// Loan definition name and type pair already exist
					11010104: 11010104,
				},
				//04
				CONTRACT: {
					//contract already bound
					11010401: 11010401,
				},
				// 07
				INVESTORS: {
					// Securities name and type pair mismatch
					11010701: 11010701,
					// Missing header row
					11010702: 11010702,
					// Missing security names
					11010703: 11010703,
					// General file error
					11010704: 11010704,
					// One of investors email is invalid
					11010705: 11010705,
					// Missing investor securities data
					11010706: 11010706,
					// Missing security types
					11010707: 11010707,
					// Duplicated emails
					11010708: 11010708,
					// Missing investors
					11010709: 11010709,
				},
				// 08
				COLLABORATE: {
					// Conflict of emails
					11010801: 11010801,
				},
				COMPLETION: {
					// Error sending collaborator invitations
					11010901: 11010901,
					// Missing securities
					11010902: 11010902,
					// Missing investors
					11010903: 11010903,
					// Warning: Missing contract files
					11010904: 11010904,
					// Warning: Existed contract not assigned to any investor
					11010905: 11010905,
					// Warning: Investors included in this MIP not linked with any contracts or documents
					11010906: 11010906,
					// Warning: None of contracts have counterparties defined
					11010907: 11010907,
					// Warning: Missing bank account
					11010908: 11010908,
					// Error: Missing programme name
					11010909: 11010909,
					// Error: Missing entity name
					11010910: 11010910,
					// Error: Max length error programme name
					11010911: 11010911,
					// Error: Max length error entity name
					11010912: 11010912,
					// Error: Investors without shares but with contracts
					11010913: 11010913,
				},
			},
			// 02
			MANAGE: {
				// 01
				INVESTORS: {
					//Error sending investor invitations
					11020101: 11020101,
					// Synchronous investors download exceeds the limit; use the async export
					11020102: 11020102,
				},
				// 02
				JOINER_LEAVER: {
					// There is already security with that name
					11020201: 11020201,
					// validation error - mip not found
					11020202: 11020202,
					// validation error - mip is not active
					11020203: 11020203,
					// validation error - some investor allocation has undefined email
					11020204: 11020204,
					// validation error - some investor has not completed InvestmentWorkflow
					11020205: 11020205,
					// error sending emails about new allocations
					11020206: 11020206,
					// Not all emails provided in excel file are in our system
					11020207: 11020207,
					// error not all investors have valid email
					11020208: 11020208,
					// 01
					PARSE_TO_JSON: {
						// Missing header row
						1102020101: 1102020101,
						// Securities name and pair not found
						1102020102: 1102020102,
						// Securities names empty
						1102020103: 1102020103,
						// One of investors email is invalid
						1102020104: 1102020104,
						// General file error
						1102020105: 1102020105,
						// Securities types empty
						1102020106: 1102020106,
						// Loan definition name and pair not found
						1102020107: 1102020107,
					},
				},
				// 03
				SETTINGS: {
					// Error sending invitation to collaborator
					11020302: 11020302,
					// Error updating collaborator - at least one must be contact person
					11020303: 11020303,
					// Error deleting collaborator - at least one must stay
					11020304: 11020304,
					// Error You're not permitted
					11020305: 11020305,
					// Error You can't remove yourself
					11020306: 11020306,
					// Error: There can only be one OWNER for a MIP
					11020307: 11020307,
					// Error: User does not exist in MIP
					11020308: 11020308,
					// Error: Cannot delete the last programme entity
					11020309: 11020309,
					// Error: Cannot delete an entity with securities used in the MIP
					11020310: 11020310,
					// Error: Entity cannot issue securities for this deal
					11020311: 11020311,
				},
				//04
				DOCUMENT_WORKFLOW: {
					// No fileId provided
					11020401: 11020401,
					// Failed to create file
					11020402: 11020402,
				},
				//05
				LOANS: {
					// Can't repay higher loan amount than transaction cost
					11020501: 11020501,
					// Can't repay higher loan amount than available balance
					11020502: 11020502,
					// Cannot mutate loans where documents have already been generated
					11020503: 11020503,
				},
				// 07
				ALLOCATIONS: {
					// Cannot update allocations where documents have already been generated
					11020701: 11020701,
					// Duplicate rows for the same investor and security are not allowed
					11020702: 11020702,
					// Delete? must be a boolean value
					11020703: 11020703,
					// Investor not found in MIP
					11020706: 11020706,
					// Security not found for name/type
					11020707: 11020707,
					// Investor does not have an in-progress investment in this MIP
					11020708: 11020708,
					// Allocated units must be a number greater than or equal to 0
					11020709: 11020709,
					// Allocated units must align with the security unit denominator
					11020710: 11020710,
					// Cost must be a number greater than or equal to 0
					11020711: 11020711,
					// Expected transaction type must be one of: issue, transfer, redemption, cancellation
					11020712: 11020712,
					// MIP or entity not found
					11020713: 11020713,
				},
				// 08
				LEGAL_DOCUMENTS: {
					// Cannot update legal documents where documents have already been generated
					11020801: 11020801,
				},
				VESTING: {
					// Vesting start date cannot be earlier than the transaction date minus full vesting period
					11020601: 11020601,
					// Vesting start date cannot be later than the transaction date plus first vesting event
					11020602: 11020602,
					// Percentage, performance and unvested percentages total must not exceed 100%
					11020603: 11020603,
					// Subjects not legal persons or part of deal
					11020604: 11020604,
					// Hurdle incremental percentages total exceeding 100%
					11020605: 11020605,
					// Each hurdle must have unique threshold values
					11020606: 11020606,
					// MOIC threshold required for hurdle
					11020607: 11020607,
					// XIRR threshold required for hurdle
					11020608: 11020608,
					// Duplicate person IDs in measurement subjects
					11020609: 11020609,
					// Measurement subjects must not include the issuer of the security
					11020610: 11020610,
					// Cannot set performance vesting when security has ratchet schedule
					11020611: 11020611,
					// Cannot set performance vesting when security has participation threshold
					11020612: 11020612,
					// Vesting term has no schedule configured
					11020613: 11020613,
					// Measurement subjects require a programme-scoped vesting term
					11020614: 11020614,
				},
			},
			// 03
			SIMPLE_DOCUMENT_WORKFLOW: {
				// 01
				CREATE_DOCUMENTS: {
					// Invalid document IDs provided
					11030101: 11030101,
					// Invalid investors IDs provided
					11030102: 11030102,
					// One or more master documents cannot be sent through this flow
					11030103: 11030103,
				},
			},
		},
		//2
		CAP: {
			//01
			MANAGE: {
				// bulk upload failed - all entities already exist
				120101: 120101,
				// bulk security upload failed - all securities already exist
				120102: 120102,
				// bulk security upload failed - all securities must have same currency
				120103: 120103,
				// Delete entity failed
				120104: 120104,
				// delete person failed due to linked investor or user
				120105: 120105,
				// delete person failed due to linked fund manager relation
				120106: 120106,
				// delete person failed due to linked MIP entity relation
				120107: 120107,
				// delete person failed due to linked loan funder relation
				120108: 120108,
			},
			TRANSACTIONS: {
				// source is required
				120201: 120201,
				// destination is required
				120202: 120202,
				// source and destination cannot be the same
				120203: 120203,
				// Destination must be entity ID
				120204: 120204,
				// Source must be entity ID
				120205: 120205,
				// Insufficient data
				120206: 120206,
				// Transaction type required
				120207: 120207,
				// bulk source and destination cannot be the same
				120208: 120208,
				// bulk Destination must be entity ID
				120209: 120209,
				// bulk Source must be entity ID
				120210: 120210,
				// bulk delete some transactions as they originated in an investment programme
				120211: 120211,
				// destination person is not permitted for specified destination MIP
				120212: 120212,
				// source person is not permitted for specified source MIP
				120213: 120213,
				// ISSUE: source must be MIP entity for destination MIP
				120214: 120214,
				// ISSUE: source must be investor or vehicle for source MIP
				120215: 120215,
				// REDEMPTION: source must be investor or vehicle when destination MIP specified
				120216: 120216,
				// REDEMPTION: destination must be MIP entity when source MIP specified
				120217: 120217,
				// Non-fractional security requires integer units
				120218: 120218,
				// Destination person not found
				120219: 120219,
				// Bought for person not found
				120220: 120220,
				// Bought for person must be natural person
				120221: 120221,
				// Destination person is natural person that are not eligible to become investor in programme because it has no user and has no email to create user
				120222: 120222,
				// Destination person is legal person but no boughtForPersonId provided
				120223: 120223,
				// Destination person is legal person but its not a PIV for bought for person
				120224: 120224,
				// Bought for person is natural person that are not eligible to become investor in programme because it has no user and has no email to create user
				120225: 120225,
				// Source person not found
				120226: 120226,
				// Source person is natural person that are not eligible to become investor in programme because it has no user and has no email to create user
				120227: 120227,
				// Source person is legal person but no soldForPersonId provided
				120228: 120228,
				// Sold for person not found
				120229: 120229,
				// Sold for person must be natural person
				120230: 120230,
				// Source person is legal person but its not a PIV for sold for person
				120231: 120231,
				// Sold for person is natural person that are not eligible to become investor in programme because it has no user and has no email to create user
				120232: 120232,
				// If the security is a management loan in a MIP then the seller holding must match that MIP
				120233: 120233,
				// Participation threshold expressed as is required for transaction with security participation threshold basis set to Total Proceeds Within Tier
				120234: 120234,
				// Participation threshold is required for transactions with Security participation threshold
				120235: 120235,
				// Create transaction: Security's issuer cannot issue securities in the current deal
				120236: 120236,
				// A non-Both interest (legal/beneficial split) requires a security with a nominee structure
				120237: 120237,
				// 120238 RETIRED (CAP-1062): formerly "a split title cannot be recorded on a deal with splits/
				// reverse-splits/conversions/vesting". The dual-rail fold now supports all of those (it
				// renumbers both rails on a split/reverse-split/conversion and folds a vesting redemption per
				// rail), so the guard was removed. The code is left reserved — do not reuse the number.
				// A nominee share must be issued with BOTH legal and beneficial title together (a lone
				// single-title ISSUE is not allowed — use the paired issue, which mints BOTH then transfers
				// one rail to the other holder). Single-title TRANSFER/REDEMPTION remain allowed.
				120239: 120239,
				// CAP-2011: split-interest requires a transaction whose interest is "Both" (a single-title
				// transaction has nothing to split).
				120240: 120240,
				// Split-interest is supported on ISSUE / TRANSFER / REDEMPTION / CANCELLATION. Every other
				// type has no single-title semantics in the engine, so there is nothing for the two legs
				// to describe. An ISSUE splits safely because the twins share one serial range through
				// the pair memo, which is the CAP-1062 rule that a share is minted with both titles on
				// the same serials.
				120241: 120241,
				// RETIRED (CAP-2035). It froze the interest field on a single-title leg, because
				// retitling one back to "Both" while its sibling existed double-minted that rail. That
				// is now the pair MERGE — the two legs collapse into one Both row (120243 / 120251) —
				// so there is nothing left to refuse and the code has no throw site. The number is left
				// reserved; do not reuse it.
				120242: 120242,
				// CAP-1976: a change to a paired transaction (shared interestPairId) that also applies to
				// its linked leg — date/units on ISSUE/REDEMPTION/CANCELLATION legs, security or buyer
				// holding on any leg, or a type change — needs the client to acknowledge the pair effect
				// by resubmitting with confirmPairSync: true. The flag is an acknowledgment, not data:
				// the server recomputes the synced values from its own in-transaction sibling read.
				120243: 120243,
				// CAP-1976: blocked change on a paired transaction. A single-title leg's interest is
				// fixed by its pair — delete the pair and recreate it — and no leg may be retitled to
				// its sibling's interest (the one-live-leg-per-title invariant). A type change applies
				// to both legs, except REDEMPTION/CANCELLATION -> ISSUE, which inverts what the
				// transaction records. Retitling to "Both" is the merge, not a block: see 120251.
				120244: 120244,
				// CAP-1976: operation not available on a leg of an interest pair — unit split, merging
				// with another transaction, or a bulk update that would desynchronise the pair. Edit the
				// legs individually or delete the pair first.
				120245: 120245,
				// CAP-1976 inseparable redemption: the holder's position on the named rail is carried in
				// more than one fold partition — (entity, mip, held_for) — and the request named none, so
				// "redeem N from this holder" does not identify which serials to retire. Name the
				// partition (fromMipId / soldForId). Also covers the holder holding nothing at all on
				// that rail for this security.
				120246: 120246,
				// CAP-1976 inseparable redemption: the holder does not hold the requested number of units
				// on the named rail, so the take would be short and would retire serials it does not own.
				120247: 120247,
				// CAP-1976 inseparable redemption: some of the serials the redemption would retire have no
				// paired counterpart title on ANOTHER holder's rail — either nobody holds it or the
				// redeeming holder holds both rails itself, which is a non-nominee region. Retiring them
				// would leave a title orphaned; use a standard "Both" redemption for non-nominee holdings.
				120248: 120248,
				// CAP-2033: a single-title REDEMPTION/CANCELLATION must retire its paired counterpart
				// title too, so it may only exist as a leg of a resolved group (a stamped
				// redemptionGroupId). A lone one retires one rail and leaves the other standing, which is
				// how a title-split register drifted out of balance: the beneficial register read 100 and
				// the legal register 200 over the same shares. Route it through the inseparable
				// redemption, which derives the counterpart legs.
				120249: 120249,
				// CAP-2033: every resolver-measured field of a leg of a resolved inseparable redemption
				// is FIXED — its interest (the rail the group was resolved against) and its
				// destination plus partition keys (where the counterpart title sits, which is how the
				// engine retires from the partition the resolver measured). Rewriting any of them
				// silently unpicks that correspondence and the two registers drift apart again;
				// observed twice, once via a retitle and once via a destination change, each leaving
				// 200 units on one register against 100 on the other. Delete the group and redeem
				// again with the values you meant.
				120250: 120250,
				// CAP-2035: merging a legal/beneficial pair back into one "Both" row needs the two
				// legs to have a single-row form. Legs that run between different parties, or that
				// name a different programme or holder-for, do not: one row carries one of each, so
				// the merge would silently drop whichever it could not keep.
				120251: 120251,
				// CAP-2035: a bulk delete removes what the user selected and nothing else they could
				// have picked themselves. When a selected row's linked leg is visible in the grid and
				// was left out, the delete is refused rather than widened — the grid showed both legs,
				// so taking the unselected one is a surprise, not a convenience. A HIDDEN counterpart
				// (the seller-to-seller ghost of a split transfer) is the exception: it cannot be
				// selected, and leaving it live strands a half-pair.
				120252: 120252,
				// CAP-2033 rails-aligned transfers: a single-title TRANSFER is refused when the
				// counterpart title over the units it moves is spread across more than one position —
				// one interest pair carries at most one complement-titled ghost leg, so the spread
				// cannot be kept aligned. Transfer in smaller single-counterpart lots instead.
				120253: 120253,
				// CAP-2039: the inseparable redemption was previewed, and the re-resolve at write time
				// answers differently — the register moved in between, so the legs about to be written
				// retire different counterparts from the ones the user was told about. Writing them
				// would make the disclosure a lie, so the write is refused and the caller re-previews.
				// Distinct from 120250, which freezes the fields of an EXISTING group: this is the
				// window between reading the register and writing to it.
				120254: 120254,
				// CAP-1976 audit: a legal/beneficial split is only meaningful on the types the engine
				// gives single-title semantics to — issue, transfer, redemption, cancellation,
				// shareholder contribution. Everything else folds title-blind, yet a single-title row
				// still flips the deal's dual gate through the evidence trigger, so the whole read
				// model changes shape for a transaction that cannot express a rail.
				120255: 120255,
				// RETIRED before it ever shipped. It refused a single-title TRANSFER whose serials had
				// no counterpart holder, but the counterpart take comes off the high end of the
				// seller's stack — so one uncovered region blocked EVERY later single-interest
				// transfer by that holder, whatever its size. The divergence reaches the user through
				// the oversold signal instead. Number reserved; do not reuse it.
				120256: 120256,
				// CAP-1976 audit: the person is a party to live transactions linked in an interest pair
				// or a resolved inseparable redemption. Deleting them nulls the parties the resolver
				// owns, which the row-level guards refuse for exactly the same fields.
				120257: 120257,
				// CAP-1976 audit: the deal's nominee structure cannot be switched off while live
				// split-title transactions exist. The fold keeps running dual off the evidence trigger
				// while every read surface gates the rail on this flag, so the beneficial owners vanish
				// from the UI but stay in the ledger.
				120258: 120258,
				// CAP-1976 audit: the same, for a person whose issued securities carry live split-title
				// transactions.
				120259: 120259,
				// CAP-1976 audit: the same, for a security leaving UNITS. Split title requires it, so
				// the change would make its own existing rows unwritable.
				120260: 120260,
				// CAP-1976 audit: an investment release cannot record a nominee-structured security as
				// a plain issue — it writes one Both-titled row, so the legal title lands on the
				// beneficial owner and no nominee leg exists. Record it as a paired issue instead.
				120261: 120261,
				// CAP-1976 audit: a conversion out of a security that carries live split-title
				// transactions, into one that is not nominee-structured. The engine copies the
				// beneficial rail onto the target regardless, producing a divergence the write layer
				// would then refuse either to write or to repair.
				120262: 120262,
			},
			SECURITIES: {
				// Security interest definition: if compounding period is specified, it must be no shorter than the accrual period
				120304: 120304,
				// Security interest definition: if principal is either value per unit or value for total issue, principalValue must be specified
				120305: 120305,
				// Security Security: there cannot be more than one entry with the same trackingSecurityIssuerId and trackedSecurityId
				120306: 120306,
				// Security exchange rights: exchangedForSecurity must be issued in units
				120307: 120307,
				// Security exchange rights: exchangedForSecurity must not have exchange rights already set
				120308: 120308,
				// Security exchange rights: period basis date is required when period basis is fixed date
				120309: 120309,
				// Security exchange rights: Period basis interval start must be before or equal to end
				120310: 120310,
				// Security exchange rights: first interest date needs to be after the deemed start date
				120311: 120311,
				// Security exchange rights: security and exchangedForSecurity must both be from the same issuer
				120312: 120312,
				// Security: security must be issued in units and have no residue rights
				120313: 120313,
				// Security: cannot delete because of existing exchange rights relations
				120314: 120314,
				// Security: Cannot set residueParticipationThreshold if residueRights === false
				120315: 120315,
				// Security: participationThresholdBasisTier must be an integer where residueParticipationThresholdBasis equals Total proceeds within a tier
				120316: 120316,
				// Security: Cannot set residueRights to false if residueParticipationThreshold is true
				// Security exchange rights: security is already a target of another exchange right
				120318: 120318,
				// Security exchange rights: period basis date must be null when relative to issue date
				120319: 120319,
				// Security exchange rights: interval fields must be null when fixed date
				120320: 120320,
				// Security exchange rights: cannot set when income rights or catch-up rights exist
				120321: 120321,
				// Security income rights: cannot set when exchange rights exist
				120322: 120322,
				// Security catch-up rights: cannot set when exchange rights exist
				120323: 120323,
				// Security exchange rights: additional price fields must be null when rate is 0 or null
				120324: 120324,
				// Security event: cannot convert between securities with different participation threshold configurations
				120325: 120325,
				// Tracking securities cannot track other securities from the same issuer
				120326: 120326,
				// Security exchange rights: all date/interval fields must be null when unrestricted
				120327: 120327,
				// Ratchet: metric subjects must not include the issuer of the ratchet security
				120328: 120328,
				// Ratchet: cannot set ratchet schedule on security without residue rights
				120329: 120329,
				// Ratchet: cannot set ratchet schedule when participation threshold is enabled
				120330: 120330,
				// Ratchet: entry entitlementPercentage must be greater than initialEntitlementPercentage
				120331: 120331,
				// Ratchet: moicThreshold required when metricType includes MOIC
				120332: 120332,
				// Ratchet: xirrThreshold required when metricType includes XIRR
				120333: 120333,
				// Ratchet: metric subjects must not contain duplicate personIds
				120335: 120335,
				// Ratchet: each entry must have a unique order value
				120336: 120336,
				// Person cannot issue securities
				120337: 120337,
				// Ratchet: cannot set ratchet schedule when security has performance vesting
				120338: 120338,
				// Nominee structure: security can only be a nominee structure when its issuer is a nominee structure
				120339: 120339,
				// Nominee structure: security must be issued in units to have a nominee structure
				120340: 120340,
				// Ratchet: schedule must contain at least one entry
				120341: 120341,
				// Ratchet: schedule must contain at least one metric subject
				120342: 120342,
				// Residue participation requires a security issued in units
				120344: 120344,
			},
			//04
			PERSONS: {
				// Person with such email already exist
				120401: 120401,
				// Can't update person email as user already exists in workOS
				120402: 120402,
				// Tax residence uniqueness constraint
				120403: 120403,
				// Provide person email
				120404: 120404,
				// TIN already held by another person in the deal
				120405: 120405,
			},
			RANKS: {
				// A rank cannot be both tracking and residue
				120501: 120501,
				// A tracking rank already exists
				120502: 120502,
				// A residue rank already exists
				120503: 120503,
				// Tracking and residue ranks cannot be updated
				120504: 120504,
				// A rank's sort order cannot be higher or equal to an existing tracking rank's
				120505: 120505,
				// A rank's sort order cannot be lower or equal to an existing residue rank's
				120506: 120506,
				// Cannot delete rank that has securities assigned to it
				120507: 120507,
			},
			SECURITY_RANK: {
				// Tracking security features can only belong to a tracking rank
				120601: 120601,
				// Right to residue is never ranked
				120602: 120602,
				// Tracking ranks only hold tracking security features; the residue rank never holds ranked features
				120603: 120603,
				// Only interest principal security features can be split
				120604: 120604,
			},
			// 07
			DOCUMENTS: {
				// Cannot link a document to a person or transaction that does not exist
				120701: 120701,
			},
		},
		// `This deal cannot be deleted as investors have already been invited into it`
		1000: 1000,
		// 3
		VALUATION: {
			// 01
			HOLDINGS: {
				// Parent block info not found
				130101: 130101,
				// Empty holding found
				130102: 130102,
				// Negative units in a holding
				130103: 130103,
				// Invalid security definition ID in holding
				130104: 130104,
				// Unimplemented: Split/conversion-related actions on interest-bearing securities
				130105: 130105,
			},
			// 02
			GRAPH: {
				// Validation error - scoped person id not found in holdings graph
				130201: 130201,
				// Cycle detected in the graph
				130202: 130202,
				// Holding graph cannot be topologically sorted
				130203: 130203,
				// Generation mismatch for a person and his/her corresponding MIP
				130204: 130204,
				// Valuation compute service unreachable / non-OK stream response
				130205: 130205,
				// Error creating workbook
				130206: 130206,
				// Stale valuation result shape (pre-deploy result requested post-deploy) - recalculate
				130207: 130207,
			},
			// 03
			FOREIGN_EXCHANGE: {
				// Validation error - should not provide multiple custom rates for the same currency
				130301: 130301,
				// Validation error - should not provide custom rates for the default currency
				130302: 130302,
				// Failed to fetch latest exchange rate
				130303: 130303,
				// Failed to fetch historical exchange rate
				130304: 130304,
				// Validation error - a currency in use has neither a provider nor a custom rate
				130305: 130305,
			},
			// 04
			VALUATION_INPUT: {
				// Validation error - invalid classifier type specified
				130401: 130401,
			},
			// 05
			VALUATION_PERSON_INPUT: {
				// Validation error - invalid classifier type specified
				130501: 130501,
			},
			// 06
			INTEREST: {
				// No income rights found
				130601: 130601,
				// Invalid start or end date
				130602: 130602,
				// The compounding period is less than the accrual period
				130603: 130603,
				// Invalid first interest date
				130604: 130604,
				// Invalid day count convention
				130605: 130605,
			},
			// 07
			PATH: {
				// Validation error - deal not found
				130701: 130701,
				// Validation error - valuation not found
				130702: 130702,
				// Validation error - valuation input not found
				130703: 130703,
				// Validation error - security value override not found
				130704: 130704,
				// Validation error - valuation input adjustment not found
				130705: 130705,
				// Validation error - person not found
				130706: 130706,
				// Validation error - valuation person input not found
				130707: 130707,
				// Validation error - MIP not found
				130708: 130708,
				// Validation error - security definition not found
				130709: 130709,
				// Validation error - Missing deal-id in header
				130710: 130710,
			},
			// 08
			VALUATION_CLASSIFIER: {
				// Validation error - invalid classifier type specified
				130801: 130801,
			},
		},
	},
	//2
	SHAREHOLDER: {
		// Register
		REGISTER: {
			// Investor already registered or registration token not valid
			2000001: 2000001,
			// Investor not found
			2000002: 2000002,
			// Investor already active
			2000003: 2000003,
			// User already registered
			2000004: 2000004,
		},
		//01
		INVESTMENT: {
			//00
			DASHBOARD: {
				// Multiple InvestmentWorkflow found
				2010001: 2010001,
			},
		},
	},
	//3
	GENERIC: {
		// 01
		CONTRACTS: {
			// 01
			SIGNING: {
				// Wet ink signature: mismatch number of pages
				3010101: 3010101,
				// Every document in a bulk batch requires a witness, which bulk cannot nominate
				3010102: 3010102,
				// A caller selected more documents than one bulk batch holds. Raised for an
				// admin selection, and for a portal signatory's explicit selection; a portal
				// signatory who sends no selection still has their overflow deferred instead.
				3010103: 3010103,
				// A portal signatory selected a document that cannot be bulk signed (needs a
				// witness, not signable, or not theirs).
				3010104: 3010104,
				// eID Easy returned no signed file for a bulk package
				3010105: 3010105,
			},
		},
		// 02
		FILE: {
			// Tried to upload empty file
			30201: 30201,
			// Unreadable PDF file
			30202: 30202,
			// Could not find investor signature
			30203: 30203,
			// Can't create loan with identical name and type, but different funder.
			30204: 30204,
			// File format must be PDF
			30205: 30205,
			// PDF file does not contain fillable fields
			30206: 30206,
		},
		// 03
		XLSX: {
			// 01
			SHARE: {
				// Cost or number does not meet requirements
				30301: 30301,
				// Loans total amount greater than total securities cost
				30302: 30302,
				// Loan amount does not meet requirements
				30303: 30303,
			},
		},
		//04
		IBAN: {
			// Failed to save bank data, iban not valid
			30401: 30401,
		},
		//05
		SETTINGS: {
			//00
			PASSWORD: {
				// Cannot change password due to change email process in progress
				30500001: 30500001,
			},
			//01
			EMAIL: {
				// Cannot request change email due to change email process in progress
				30501001: 30501001,
				// Cannot find email request change
				30501002: 30501002,
				// User email already exists in db
				30501003: 30501003,
				// Email request change missing token
				30501004: 30501004,
			},
		},
		MANAGE: {
			// Investor has completed investmentWorkflow, cannot remove investor
			40201: 40201,
		},
	},
	AUTH: {
		INVITATION: {
			// Invalid WorkOs invitation
			50000: 50000,
		},
		CHANGE_PASSWORD: {
			// Old password does not match
			50001: 50001,
		},
		CHANGE_EMAIL: {
			// Restrict user to change email if the user has any SSO connections and is an admin role user
			50002: 50002,
			// newEmail does not match new requested email address
			50004: 50004,
			// cannot delete email as user verified
			50005: 50005,
			// cannot find user changeEmailRequest entry
			50006: 50006,
			// Has same new email
			50003: 50003,
			50007: 50007,
			50008: 50008,
			50010: 50010,
			50009: 50009,
		},
		CREDENTIALS: {
			50011: 50011,
			50012: 50012,
			50013: 50013,
			50014: 50014,
			50015: 50015,
		},
	},
	//4
	GODMODE: {
		//01
		IMPORT: {
			// Wrong calculated investor state
			40101: 40101,
		},
		//02
		MANAGE: {
			// You can remove only review contracts
			40202: 40202,
			// Investor contract file can't be deleted - it's completed
			40203: 40203,
			// Contract file can't be deleted - it's completed
			40204: 40204,
			// Mip can't be unlocked - not all investors have approved status
			40205: 40205,
		},
	},
	INVITATION: {
		// Cannot invite user to entity
		60000: 60000,
	},
	//7
	FUND: {
		// Cannot unlink deal from fund because person scopes exist
		70001: 70001,
		// You can only link legal fund persons to deals
		70002: 70002,
	},
};

export interface ErrorCode {
	code: number;
	message?: string;
	stack?: string;
}

/**
 * Framework-free domain error for pure compute code (the valuation engine). Deliberately does NOT
 * extend Nest's HttpException: the engine runs inside the compute worker, whose bundle must stay
 * clear of @nestjs/* (the framework require dominated worker bootstrap, WAT-743).
 * GlobalExceptionFilter maps it to the same 400 + { code, message } wire shape as BusinessException,
 * so backend in-process engine usage keeps an identical error contract.
 */
export class EngineError extends Error {
	public readonly code: number;

	constructor(errorCode: ErrorCode) {
		super(errorCode.message ?? 'EngineError');
		this.name = 'EngineError';
		this.code = errorCode.code;
	}
}
